import $ from 'jquery';
import 'custom-select/build/jquery.custom-select.min.js';

export class Teamlist {

    constructor() {

        this.$filter = $('.team__select');
        this.$list = $('.team__list');
        this.$items = this.$list.children('.loadable__item');
        this.$teamItems = this.$items.find('.team__item');
        this.$btn = $('.btn-more');

        this.init();
        this.filter();

    }

    // hide items
    init() {

        let maxItems = this.$list.data('show');
        this.$items.slice(0, maxItems).addClass('loadable__item--visible').show();

        // load more btn
        this.$btn.on('click', (e) => {

            let $visible = $('.loadable__item--visible');
            let $hidden = this.$items.not($visible);
            let $more = $hidden.slice(0, maxItems).addClass('loadable__item--visible').show();

            if ($more.hasClass('loadable__item--last')) {
                $(e.currentTarget).hide();
            }

        });

        // toggle active on click
        this.$teamItems.on('click', (e) => {
            this.$teamItems.removeClass('active');
            $(e.currentTarget).toggleClass('active');
        });


    }

    // team fitler
    filter() {

        let maxItems = this.$list.data('show');

        this.$filter.customSelect();
        this.$filter.on('change', (e) => {

            if(e.currentTarget.value) {
                let $locationTeam = $(`.team__filter[data-filter*=${e.currentTarget.value}]`);

                console.log($locationTeam);

                $locationTeam.addClass('loadable__item--visible');
                this.$items.not($locationTeam).removeClass('loadable__item--visible');
                this.$btn.hide();
            }
            else {
                this.$items.removeClass('loadable__item--visible')
                if(maxItems) {
                    this.$items.slice(0, maxItems).addClass('loadable__item--visible').show();
                } else {
                    this.$items.addClass('loadable__item--visible').show();
                }
                this.$btn.show();
            }

        });


    }

}